import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const EditHomeWorkPricing = () => {
  const [schoolClassName, setSchoolClassName] = useState([]);
  const [schoolClassNameId, setSchoolClassNameId] = useState();
  const [price, setPrice] = useState();

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { id } = useParams();

  // single get
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/pricing/home-work/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result?.data?.data);
        const data = result?.data?.data;
        setSchoolClassNameId(data?.classId?._id);
        setPrice(data?.price);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // CLASSES DATA GET FUN AXIOS --
  const getClasses = () => {
    axios
      .get(`${API_BASE_URL}/classes`)
      .then((resp) => {
        const { data } = resp.data;
        setSchoolClassName(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getClasses();
  }, []);

  const handleAddNewHomeWorkPricing = () => {
    navigate("/add-home-work-pricing");
  };
  const handleViewAllHomeWorkPricing = () => {
    navigate("/all-home-work-pricing");
  };
  const payload = {
    classId: schoolClassNameId,
    price,
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .put(`${API_BASE_URL}/admin/pricing/home-work/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("Price Updated Successfully.");
        navigate("/all-home-work-pricing");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while Updating Price");
      });
  };

  return (
    <div id="add-subject-inner-wrapper">
      <div className="superheader">
        <div className="subjectHeaderdiv">
          <h5>Update Home Work Pricing</h5>
          <div className="subjectdiv2">
            <button
              className="handleNewSubject"
              onClick={handleAddNewHomeWorkPricing}
            >
              + Add New Pricing
            </button>
            <button
              className="allSubjects"
              onClick={handleViewAllHomeWorkPricing}
            >
              All Pricing
            </button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <h4 className="subject-detail">Update Home Work Pricing</h4>
          <form
            className="subject-detail-form"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Class Name</label>
              </div>
              <select
                className="select-dropdown"
                value={schoolClassNameId}
                onChange={(e) => setSchoolClassNameId(e.target.value)}
                required
              >
                <option value="">-Select Class</option>
                {schoolClassName &&
                  schoolClassName.slice(0, 8).map((classes) => (
                    <option value={classes._id} key={classes._id}>
                      {classes?.className}
                    </option>
                  ))}
              </select>
            </div>

            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label">Price</label>
              </div>
              <input
                type="text"
                placeholder="Enter Price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
            </div>

            <div className="school-subj-form-btns">
              <button
                className="btn-search"
                type="submit"
                // onClick={handleSubmit}
              >
                Save
              </button>
              <button className="btn-cancel">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditHomeWorkPricing;
